import { motion } from "framer-motion";
import { Star } from "lucide-react";

export const ProgressIndicator = ({ totalSteps = 5, currentStep = 0, completedSteps = [] }) => {
    return (
        <div className="flex items-center justify-center gap-3">
            {Array.from({ length: totalSteps }).map((_, index) => {
                const isCompleted = completedSteps.includes(index);
                const isActive = currentStep === index;
                
                return (
                    <motion.div
                        key={index}
                        className="relative"
                        initial={{ opacity: 0, scale: 0 }}
                        animate={{ opacity: 1, scale: 1 }}
                        transition={{ delay: index * 0.1, duration: 0.3 }}
                    >
                        {isCompleted ? (
                            <motion.div
                                initial={{ scale: 0, rotate: -180 }}
                                animate={{ scale: 1, rotate: 0 }}
                                transition={{ type: "spring", stiffness: 200, damping: 15 }}
                                className="relative"
                            >
                                <Star
                                    className="w-4 h-4 text-primary fill-primary"
                                    strokeWidth={1.5}
                                />
                                <motion.div
                                    className="absolute inset-0"
                                    animate={{
                                        boxShadow: [
                                            "0 0 5px hsl(43 66% 52% / 0.4)",
                                            "0 0 12px hsl(43 66% 52% / 0.6)",
                                            "0 0 5px hsl(43 66% 52% / 0.4)"
                                        ]
                                    }}
                                    transition={{ duration: 2, repeat: Infinity }}
                                    style={{ borderRadius: "50%" }}
                                />
                            </motion.div>
                        ) : (
                            <motion.div
                                className={`w-2.5 h-2.5 rounded-full border transition-all duration-300 ${
                                    isActive
                                        ? "border-primary bg-primary/30"
                                        : "border-muted-foreground/30 bg-transparent"
                                }`}
                                animate={isActive ? {
                                    boxShadow: [
                                        "0 0 5px hsl(43 66% 52% / 0.3)",
                                        "0 0 10px hsl(43 66% 52% / 0.5)",
                                        "0 0 5px hsl(43 66% 52% / 0.3)"
                                    ]
                                } : {}}
                                transition={{ duration: 2, repeat: Infinity }}
                            />
                        )}
                    </motion.div>
                );
            })}
        </div>
    );
};

export default ProgressIndicator;
